/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';
import type { IPackageBlockItem } from '../types';
import { PACKAGE_INFO_ITEM_TEST_ID } from '../constants';

const PackageBlockItem: FC<IPackageBlockItem> = ({
  icon,
  className,
  text = null,
  children = null,
  contentClass,
  onClickRoomImage,
  packageId = 0,
  isMobile,
  hasError = false,
}) => (
  <StyledPackageBlockItemRow
    className={className}
    data-testid={PACKAGE_INFO_ITEM_TEST_ID}
    isMobile={isMobile}
    $hasError={hasError}
  >
    {icon && (
      <StyledIcon onClick={() => onClickRoomImage?.(packageId)}>
        {icon}
      </StyledIcon>
    )}
    <StyledContent className={contentClass}>
      {text && <StyledText isMobile={isMobile}>{text}</StyledText>}
      {children}
    </StyledContent>
  </StyledPackageBlockItemRow>
);

const StyledPackageBlockItemRow = styled.div<{
  isMobile: boolean;
  $hasError: boolean;
}>`
  padding-left: ${({ isMobile }) => (isMobile ? 0 : 18)}px;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  > i {
    &[class*='check'] {
      path {
        stroke: #4d4d4d;
      }
    }
  }

  > i svg {
    width: inherit;
    height: inherit;
  }
  ${({ isMobile }) =>
    isMobile &&
    `
    > i {
      &[class*='garranty'] {
        margin: 0 13px 0 6px;
      }
    }
  `}
  ${({ $hasError }) =>
    $hasError &&
    `
    margin-bottom: 5px;
    padding: 6px 18px 6px 18px;
    width: 100%;
    background: #e6e9ee;
    border-radius: 4px;
  `}
`;

export const StyledIcon = styled.div`
  margin-right: 8px;
  padding-top: 1px;
  display: flex;
  max-height: 30px;
  justify-content: center;
  align-items: baseline;
  flex-basis: 32px;
`;

export const StyledContent = styled.div`
  flex-basis: 100%;
`;

const StyledText = styled.span<{ isMobile: boolean }>`
  font-size: 14px;
  color: #4d4d4d;
  & + * {
    margin-left: 13px;
  }
  ${({ isMobile }) => isMobile && `font-size: 13px;`}
`;

export default PackageBlockItem;
